import React from "react";
import maskedGroup from "../../assets/maskedGroup.png";

const HeroImage = () => {
  return (
    <div className="flex-[1.3] hidden lg:block  h-full">
      <div className=" h-full  ">
        <img src={maskedGroup} alt="dama" className=" w-full  " />
      </div>
    </div>
  );
};

export default HeroImage;
